import { AuthStore } from '@/stores/Auth.js'

const urlBase = process.env.VUE_APP_api;

export const api = {
  autoriza: async function () {
    try {
      const auth = AuthStore();
      if (auth.token && auth.user) {
        const load = document.querySelector("#load");
        load.classList.remove('d-none')
        const isAuth = await auth.checkToken()
        if (isAuth) {
          load.classList.add('d-none')
          return true
        } else {
          auth.clear()
          load.classList.add('d-none')
          return false
        }
      } else {
        auth.clear()
        return false
      }
    } catch (error) {
      return false
    }
  },
  post: async function (rota, corpo = '', cabecalho = { "Content-Type": "application/json" }, stringfy = true) {
    try {
      var cabecalho_default = { 'X-Requested-With': 'XMLHttpRequest' }
      var corpo = (stringfy ? JSON.stringify(corpo) : corpo)
      if (cabecalho != '') {
        Object.assign(cabecalho_default, cabecalho)
      }
      
      const req = await fetch(urlBase + rota, {
        method: "POST",
        headers: cabecalho_default,
        body: corpo
      });

      var status = { 'status': req.status };

      const data = await req.json()
      Object.assign(data, status)

      return data;
    } catch (error) {
      return error
    }
  },
  get: async function (rota, cabecalho = { "Content-Type": "application/json" }) {
    var cabecalho_default = { 'X-Requested-With': 'XMLHttpRequest' }
    if (cabecalho != '') {
      Object.assign(cabecalho_default, cabecalho)
    }
    const req = await fetch(urlBase + rota, {
      method: "GET",
      headers: cabecalho_default,
    });

    var status = { 'status': req.status };
    const data = await req.json()
    Object.assign(data, status)

    return data;
  },
  fullget: async function (rota) {
    const req = await fetch(rota, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    var status = { 'status': req.status };
    const data = await req.json()
    Object.assign(data, status)

    return data;
  },

}